import { IconInfo20 } from '@lightspeed/unified-components-helios-theme/react'
import { T } from '@transifex/react'
import React, { FunctionComponent } from 'react'

/**
 * Banner shown above the payment input when the active outlet has an LSPay
 * cash discount configured. Explains that the discount requires paying the
 * full balance in a single cash payment.
 */
export const LspCashDiscountFullPaymentBanner: FunctionComponent = () => {
  return (
    // Can't use helios <Banner> because it justifies all the text to the centre
    <div className="wr-lsp-cash-discounting-banner vd-banner vd-banner--info">
      <div className="vd-banner-wrapper vd-flex vd-flex--justify-between">
        <span>
          <IconInfo20
            aria-hidden="true"
            className="vd-banner-icon"
          ></IconInfo20>
          <T
            _str="To offer cash discount, the full balance must be paid in a single cash payment."
            _context="LSPay cash discounting full payment banner"
          />
        </span>
      </div>
    </div>
  )
}
